import { render, staticRenderFns } from "./ResumenPrecioComponent.vue?vue&type=template&id=117c114e"
import script from "./ResumenPrecioComponent.vue?vue&type=script&lang=js"
export * from "./ResumenPrecioComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports